import { render, staticRenderFns } from "./MSIndRegList.vue?vue&type=template&id=286acf10"
import script from "./MSIndRegList.vue?vue&type=script&lang=js"
export * from "./MSIndRegList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports